import {KeyboardArrowDown, KeyboardArrowUp} from "@material-ui/icons";
import {
    AppBar,
    Avatar,
    Box,
    Button,
    Container,
    Divider,
    Link as MuiLink,
    ListItem,
    ListItemIcon,
    ListItemText,
    Toolbar
} from '@mui/material';
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useAuth} from "react-oidc-context";
import {Link, useLocation} from "react-router-dom";
import BellBlue from "../common/assets/bell-blue.svg";
import Bell from "../common/assets/bell.svg";
import CarBlue from "../common/assets/car-blue.svg";
import Car from "../common/assets/car.svg";
import ChartBarBlue from "../common/assets/chart-bar-blue.svg"
import ChartBar from "../common/assets/chart-bar.svg"
import FastDrive from "../common/assets/fastDrive.svg";
import FastDriveBlue from "../common/assets/fastDriveBlue.svg";
import GasStation from "../common/assets/gasStation.svg";
import GasStationBlue from "../common/assets/gasStationBlue.svg";
import HandshakeBlue from "../common/assets/handshake-blue.svg"
import Handshake from "../common/assets/handshake.svg"
import Prohibition from "../common/assets/Prohibition.svg";
import ProhibitionBlue from "../common/assets/ProhibitionBlue.svg";
import ShieldBlue from "../common/assets/shield-alt-blue.svg";
import Shield from "../common/assets/shield-alt.svg";
import TicketBlue from "../common/assets/ticket-blue.svg";
import Ticket from "../common/assets/ticket.svg";
import UsersBlue from "../common/assets/Users-blue.svg";
import Users from "../common/assets/Users.svg";
import {StyledMenu, StyledMenuItem} from "../common/menu/StyledMenu";
import {ROLES} from "../consts";
import {useGlobalState} from "../GlobalContext";
import {reportType, supportedCountries} from "../globals";
import keycloak from "../keycloak";
import LanguageMenu from "../reusable/languageMenu";
import {useStylesSidebar} from "../reusable/styles";
import {AuthorizedElement} from "../utils/AuthorizedElement";
import {currencyCode} from "../utils/formatter";
import {mapUser} from "../utils/mapUser";
import Style from "./listItems.module.css";
import ResetPasswordModal from "./resetPasswordModal";

/** Sidebar item to highlight for each route; a path also matches its sub-paths. */
const itemByPath = {
  "/parkingZones": 0,
  "/whitelist": 0,
  "/blacklist": 0,
  "/owners": 1,
  "/violations": 2,
  "/admins": 3,
  "/ticketSeries": 4,
  "/users": 5,
  "/requests": 6,
  "/managers": 7,
  "/gasStations": 8,
  "/driveOff": 9,
  "/billingInfo": 10,
  [`/report/${reportType.VIOLATIONS}`]: 11,
  [`/report/${reportType.DRIVE_OFFS}`]: 12,
  "/viewers": 13,
  "/client": 14,
};

const selectedItem = (pathname) => {
  const path = Object.keys(itemByPath).find((p) => pathname === p || pathname.startsWith(`${p}/`));
  return path === undefined ? undefined : itemByPath[path];
};

export const MainListItems = (props) => {
  const auth = useAuth();
  const { t } = useTranslation();
  const classes = useStylesSidebar();
  const selected = selectedItem(useLocation().pathname);
  const isViewer = keycloak.hasRealmRole(ROLES.PARKING_VIEWER, auth);

  const linkStyle = { color: "white", borderBottom: "1px solid white" };

  return (
    <div className={classes.root}>
      <AuthorizedElement
        roles={[
          ROLES.SYSADMIN,
          ROLES.PARKING_ADMIN,
          ROLES.PARKING_MANAGER,
          ROLES.GAS_STATION_ADMIN,
          ROLES.GAS_STATION_MANAGER,
        ]}
      >
        <div style={{ display: "flex"}}>
          <Link to="/requests" style={linkStyle}>
            <ListItem
              style={{height: '40px' }}
              button
              selected={selected === 6}
              classes={{
                selected: classes.selected,
              }}
            >
              {selected === 6 ? (
                <ListItemIcon>
                  <img
                    src={BellBlue}
                    id="beppoLogo"
                    alt="beppo-logo"
                    fill="#FFFFFF"
                  />
                </ListItemIcon>
              ) : (
                <ListItemIcon>
                  <img
                    src={Bell}
                    id="beppoLogo"
                    alt="beppo-logo"
                    fill="#FFFFFF"
                  />
                </ListItemIcon>
              )}

              <ListItemText primary={t("Sidebar.Requests")} />
            </ListItem>
          </Link>
          <ListItem
            button
            selected={selected === 6}
            style={{ borderBottom: "1px solid white" , height: "41px"}}
            classes={{
              selected: classes.selected,
            }}
          >
            <ListItemText
              primary={props.requestsNumber}
              className={Style.numberOfRequests}
              style={{ flex: 0.5 }}
            />
          </ListItem>
        </div>
      </AuthorizedElement>
      <AuthorizedElement
        roles={[ROLES.SYSADMIN, ROLES.PARKING_ADMIN, ROLES.PARKING_MANAGER, ROLES.PARKING_VIEWER]}
      >
        <Link to="/parkingZones" style={linkStyle}>
          <ListItem
            style={{height: '40px' }}
            button
            selected={selected === 0}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 0 ? (
              <ListItemIcon>
                <img
                  src={CarBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img src={Car} id="beppoLogo" alt="beppo-logo" fill="#FFFFFF" />
              </ListItemIcon>
            )}

            <ListItemText
              primary={t("Sidebar.Parking zones")}
              primaryTypographyProps={{ style: { whiteSpace: "normal" } }}
            ></ListItemText>
          </ListItem>
        </Link>
      </AuthorizedElement>

      <AuthorizedElement
        roles={[ROLES.SYSADMIN, ROLES.PARKING_ADMIN, ROLES.PARKING_MANAGER, ROLES.PARKING_VIEWER]}
      >
        <Link to="/violations" style={linkStyle}>
          <ListItem
            style={{height: '40px' }}
            button
            selected={selected === 2}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 2 ? (
              <ListItemIcon>
                <img
                  src={ProhibitionBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={Prohibition}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}

            <ListItemText primary={t("Sidebar.Violations")} />
          </ListItem>
        </Link>
      </AuthorizedElement>

      <AuthorizedElement roles={[ROLES.SYSADMIN, ROLES.PARKING_ADMIN, ROLES.PARKING_MANAGER, ROLES.PARKING_VIEWER]}>
        <Link to={`/report/${reportType.VIOLATIONS}`} style={linkStyle}>
          <ListItem
            button
            style={{ borderBottom: "1px solid white",height: '40px' }}
            selected={selected === 11}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 11 ? (
              <ListItemIcon>
                <img
                  src={ChartBarBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={ChartBar}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}
            <ListItemText primary={t("Sidebar.Report")} />
          </ListItem>
        </Link>
      </AuthorizedElement>

      <AuthorizedElement
        roles={[
          ROLES.SYSADMIN,
          ROLES.GAS_STATION_ADMIN,
          ROLES.GAS_STATION_MANAGER,
          ROLES.GAS_STATION_VIEWER
        ]}
      >
        <Link to="/gasStations" style={linkStyle}>
          <ListItem
            style={{height: '40px' }}
            button
            selected={selected === 8}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 8 ? (
              <ListItemIcon>
                <img
                  src={GasStationBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={GasStation}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}

            <ListItemText
              primary={t("Sidebar.Gas stations")}
              primaryTypographyProps={{ style: { whiteSpace: "normal" } }}
            ></ListItemText>
          </ListItem>
        </Link>
      </AuthorizedElement>

      <AuthorizedElement
        roles={[ROLES.SYSADMIN,
            ROLES.GAS_STATION_ADMIN,
            ROLES.GAS_STATION_MANAGER,
            ROLES.GAS_STATION_VIEWER]}
      >
        <Link to="/driveOff" style={linkStyle}>
          <ListItem
            style={{height: '40px' }}
            button
            selected={selected === 9}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 9 ? (
              <ListItemIcon>
                <img
                  src={FastDriveBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={FastDrive}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}

            <ListItemText primary={t("Sidebar.DriveOff")} />
          </ListItem>
        </Link>
      </AuthorizedElement>



          <AuthorizedElement
            roles={[ROLES.SYSADMIN,
              ROLES.GAS_STATION_ADMIN,
              ROLES.GAS_STATION_MANAGER,
              ROLES.GAS_STATION_VIEWER]}
          >
            <Link to={`/report/${reportType.DRIVE_OFFS}`} style={linkStyle}>
              <ListItem
                button
                style={{ borderBottom: "1px solid white",height: '40px' }}
                selected={selected === 12}
                classes={{
                  selected: classes.selected,
                }}
              >
                {selected === 12 ? (
                  <ListItemIcon>
                    <img
                      src={ChartBarBlue}
                      id="beppoLogo"
                      alt="beppo-logo"
                      fill="#FFFFFF"
                    />
                  </ListItemIcon>
                ) : (
                  <ListItemIcon>
                    <img
                      src={ChartBar}
                      id="beppoLogo"
                      alt="beppo-logo"
                      fill="#FFFFFF"
                    />
                  </ListItemIcon>
                )}
                  <ListItemText primary={t("Sidebar.Report")}/>
              </ListItem>
            </Link>
          </AuthorizedElement>

      <AuthorizedElement roles={[ROLES.SYSADMIN]}>
              <Link to={`/client`} style={linkStyle}>
                <ListItem
                  button
                  style={{ borderBottom: "1px solid white",height: '40px' }}
                  selected={selected === 14}
                  classes={{
                    selected: classes.selected,
                  }}
                >
                  {selected === 14 ? (
                    <ListItemIcon>
                      <img
                        src={HandshakeBlue}
                        id="beppoLogo"
                        alt="beppo-logo"
                        fill="#FFFFFF"
                      />
                    </ListItemIcon>
                  ) : (
                    <ListItemIcon>
                      <img
                        src={Handshake}
                        id="beppoLogo"
                        alt="beppo-logo"
                        fill="#FFFFFF"
                      />
                    </ListItemIcon>
                  )}
                  <ListItemText primary={t("Sidebar.Clients")} />
                </ListItem>
              </Link>
            </AuthorizedElement>

      <AuthorizedElement roles={[ROLES.SYSADMIN]}>
        <Link to="/admins" style={linkStyle}>
          <ListItem
            style={{height: '40px' }}
            button
            selected={selected === 3}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 3 ? (
              <ListItemIcon>
                <img
                  src={ShieldBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={Shield}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}
            <ListItemText primary={t("Sidebar.Admins")} />
          </ListItem>
        </Link>
      </AuthorizedElement>
      <AuthorizedElement
        roles={[ROLES.SYSADMIN, ROLES.PARKING_ADMIN, ROLES.GAS_STATION_ADMIN]}
      >
        <Link to="/managers" style={linkStyle}>
          <ListItem
            style={{height: '40px' }}
            button
            selected={selected === 7}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 7 ? (
              <ListItemIcon>
                <img
                  src={ShieldBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={Shield}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}
            <ListItemText primary={t("Sidebar.Managers")} />
          </ListItem>
        </Link>
      </AuthorizedElement>

        <AuthorizedElement
            roles={[ROLES.SYSADMIN, ROLES.PARKING_ADMIN, ROLES.GAS_STATION_ADMIN]}
        >
            <Link to="/viewers" style={linkStyle}>
                <ListItem
                    style={{height: '40px' }}
                    button
                    selected={selected === 13}
                    classes={{
                        selected: classes.selected,
                    }}
                >
                    {selected === 13 ? (
                        <ListItemIcon>
                            <img
                                src={ShieldBlue}
                                id="beppoLogo"
                                alt="beppo-logo"
                                fill="#FFFFFF"
                            />
                        </ListItemIcon>
                    ) : (
                        <ListItemIcon>
                            <img
                                src={Shield}
                                id="beppoLogo"
                                alt="beppo-logo"
                                fill="#FFFFFF"
                            />
                        </ListItemIcon>
                    )}
                    <ListItemText primary={t("Sidebar.Viewers")} />
                </ListItem>
            </Link>
        </AuthorizedElement>

      <AuthorizedElement
        roles={[
          ROLES.SYSADMIN,
          ROLES.PARKING_ADMIN,
          ROLES.PARKING_MANAGER,
          ROLES.GAS_STATION_ADMIN,
          ROLES.GAS_STATION_MANAGER,
          ROLES.PARKING_VIEWER,
          ROLES.GAS_STATION_VIEWER
        ]}
      >
        <Link to="/owners" style={linkStyle}>
          <ListItem
            style={{height: '40px' }}
            button
            selected={selected === 1}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 1 ? (
              <ListItemIcon>
                <img
                  src={UsersBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={Users}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}

            <ListItemText primary={isViewer? t("Columns.Beppoliceman"): t("Sidebar.Owners")} />
          </ListItem>
        </Link>
      </AuthorizedElement>

      <AuthorizedElement roles={[ROLES.SYSADMIN]}>
        <Link to="/users" style={linkStyle}>
          <ListItem
            button
            selected={selected === 5}
            classes={{
              selected: classes.selected,
            }}
            style={{ borderBottom: "1px solid white",height: '40px' }}
          >
            {selected === 5 ? (
              <ListItemIcon>
                <img
                  src={UsersBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={Users}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}
            <ListItemText primary={t("Sidebar.Users")} />
          </ListItem>
        </Link>
      </AuthorizedElement>

      <AuthorizedElement roles={[ROLES.SYSADMIN]}>
        <Link to="/ticketSeries" style={{ color: "white" }}>
          <ListItem
            button
            selected={selected === 4}
            style={{ borderBottom: "1px solid white",height: '40px' }}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 4 ? (
              <ListItemIcon>
                <img
                  src={TicketBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={Ticket}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}
            <ListItemText primary={t("Sidebar.TicketSeries")} />
          </ListItem>
        </Link>
      </AuthorizedElement>

      <AuthorizedElement roles={[ROLES.SYSADMIN]}>
        <Link to="/billingInfo" style={linkStyle}>
          <ListItem
            style={{height: '40px' }}
            button
            selected={selected === 10}
            classes={{
              selected: classes.selected,
            }}
          >
            {selected === 10 ? (
              <ListItemIcon>
                <img
                  src={ShieldBlue}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            ) : (
              <ListItemIcon>
                <img
                  src={Shield}
                  id="beppoLogo"
                  alt="beppo-logo"
                  fill="#FFFFFF"
                />
              </ListItemIcon>
            )}
            <ListItemText primary={t("Sidebar.BillingInfo")} />
          </ListItem>
        </Link>
      </AuthorizedElement>

    </div>
  );
};

const NavbarButton = ({ children, onClick, isOpen = false, ...props }) => {
    return (
        <Button
            onClick={onClick}
            endIcon={isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            color="inherit"
            sx={{
                textTransform: 'none',
                color: 'rgba(0, 0, 0, .5)',
                fontWeight: 400,
                fontSize: '1rem',
                fontFamily: 'Gilroy-Medium',
                padding: '0.5rem 0.75rem',
                borderRadius: 0,
                '&:hover': {
                    backgroundColor: 'rgba(0,0,0,0.05)',
                    color: 'rgba(0, 0, 0, .9)',
                }
            }}
            {...props}
        >
            {children}
        </Button>
    );
};


export const NavigationItems = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const user = mapUser(auth);
  const { state, updateState } = useGlobalState();
  const [resetPasswordModalOpen, setResetPasswordModalOpen] = useState(false);

  const [countryMenuAnchor, setCountryMenuAnchor] = useState(null);
  const [languageMenuAnchor, setLanguageMenuAnchor] = useState(null);
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);

  const selectedLanguage = localStorage.getItem("beppoSelectedLanguage") || "DE";
  
  const handleCountry = (newCountry) => {
    if (newCountry !== null) {
      updateState({country: newCountry, currency: currencyCode(newCountry)});
      setCountryMenuAnchor(null);
    }
  }

  const isSysAdmin = keycloak.hasRealmRole(ROLES.SYSADMIN, auth);

  return (
    <div>
      <AppBar position="static" color="inherit" elevation={1} sx={{boxShadow: "none"}}>
        <Container maxWidth="xl">
          <Toolbar
            sx={{ justifyContent: 'flex-end', gap: 2 }}
            className={"nav"}
          >
            {/* Country Dropdown */}
            <Box className={"test"}>
              <NavbarButton
                onClick={(e) => setCountryMenuAnchor(e.currentTarget)}
                isOpen={Boolean(!!countryMenuAnchor)}
              >
                {`${t("Columns.Country")}: ${t(`Countries.${state.country?.toUpperCase()}`)}`}
              </NavbarButton>

              <StyledMenu
                anchorEl={countryMenuAnchor}
                open={Boolean(!!countryMenuAnchor)}
                onClose={() => setCountryMenuAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              >
                {(() => {
                    const currentCountry = state.country?.toUpperCase();
                    const availableCountries =
                        Object.keys(supportedCountries)
                            .filter(country => country !== currentCountry);

                  return availableCountries.map((country, index) => (
                    <React.Fragment key={country}>
                      <StyledMenuItem onClick={() => handleCountry(country)}>
                        {`${t(`Countries.${country?.toUpperCase()}`)}`}
                      </StyledMenuItem>
                      {index < availableCountries.length - 1 && (
                        <Divider />
                      )}
                    </React.Fragment>
                  ));
                })()}
              </StyledMenu>
            </Box>

            {/* Language Dropdown */}
            <Box>
              <NavbarButton
                onClick={(e) => setLanguageMenuAnchor(e.currentTarget)}
                isOpen={Boolean(!!languageMenuAnchor)}
              >
                {`${t("Columns.Language")}: ${selectedLanguage.toUpperCase()}`}
              </NavbarButton>

              <StyledMenu
                anchorEl={languageMenuAnchor}
                open={Boolean(!!languageMenuAnchor)}
                onClose={() => setLanguageMenuAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              >
                <LanguageMenu onClose={() => setLanguageMenuAnchor(null)} />
              </StyledMenu>
            </Box>

            {/* User Dropdown */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Avatar sx={{ width: 32, height: 32, fontSize: 14 }}>
                {user?.firstName?.charAt(0) + "" + user?.lastName?.charAt(0)}
              </Avatar>
              <NavbarButton
                onClick={(e) => setUserMenuAnchor(e.currentTarget)}
                isOpen={Boolean(!!userMenuAnchor)}
              >
                {`${t("Columns.User")}: ${user?.firstName} ${user?.lastName}`}
              </NavbarButton>

              <StyledMenu
                anchorEl={userMenuAnchor}
                open={Boolean(userMenuAnchor)}
                onClose={() => setUserMenuAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              >
                <StyledMenuItem
                  onClick={() => {
                    setResetPasswordModalOpen(true);
                    setUserMenuAnchor(null);
                  }}
                >
                  {t("Columns.ChangePassword")}
                </StyledMenuItem>
                {isSysAdmin && (
                  <StyledMenuItem>
                      <MuiLink
                          href={process.env.REACT_APP_KEYCLOAK_URL + "realms/" + process.env.REACT_APP_KEYCLOAK_REALM + "/account/account-security/signing-in"}
                          underline="none"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{color: 'rgba(0, 0, 0, 0.87)'}}>{t('Columns.KcProfilePage')}</MuiLink>
                  </StyledMenuItem>)}
                <Divider sx={{ height: 0, borderColor: 'rgba(0, 0, 0, 0.02)' }} />
                <StyledMenuItem
                  onClick={() => {
                    auth.signoutRedirect({
                      post_logout_redirect_uri: `${process.env.REACT_APP_FRONTEND_URL}/`,
                    });
                  }}
                >
                  {t("Columns.Logout")}
                </StyledMenuItem>
              </StyledMenu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {resetPasswordModalOpen && (
        <ResetPasswordModal
          resetPasswordModalOpen={resetPasswordModalOpen}
          close={() => setResetPasswordModalOpen(false)}
        />
      )}
    </div>
  );
};
